const handleWorkerRoleFulfilled = (state, action) => {
  state.status = "succeeded";
  state.workerRoles = action.payload.data;
};
const handleWorkerDetailFulfilled = (state, action) => {
  state.status = "succeeded";
  state.workerDetail = action.payload.data;
};

const handleWorkerCommonStateInfoFulfilled = (state, action) => {
  state.status = "succeeded";
  state.workerProfileInfo = action.payload.data;
};

const handleFetchWorkerRefIdInitialsFulfilled = (state, action) => {
  state.status = "succeeded";
  state.workerRefIdInitials = action.payload.data;
};

const handleWorkerDetailTabInfoFulfilled = (state, action) => {
  state.status = "succeeded";
  state.workerDetailTabInfo = action.payload.data;
};


const handleWorkerDocumentUploadInfoFulfilled = (state, action) => {
  state.status = "succeeded";
  state.workerDocumentUploadInfo = action.payload.data;
};

const handleWorkerPhotoInfoFulfilled = (state, action) => {
  state.status = "succeeded";
  state.workerPhotoInfo = action.payload.data;
};

const handleWorkerDetailTabInfoPassportFulfilled = (state, action) => {
  state.status = "succeeded";
  state.workerDetailTabInfoPassport = action.payload.data;
};

const handleWorkerDocumentUploadInfoConsulateFulfilled = (state, action) => {
  state.status = "succeeded";
  state.workerDetailTabInfoConsulate = action.payload.data;
};

const handleGetWorkersFulfilled = (state, action) => {
  state.status = "succeeded";
  if (action.payload && action.payload.data) {
    state.workersList = action.payload.data;
    state.currentPage = action.payload.current_page;
    state.perPage = action.payload.per_page;
    state.totalPages = action.payload.last_page;
    state.totalWorkers = action.payload.total;
    state.lastUpdated = action.payload.last_update;
    state.allWorkersList = action.payload;
  } else {
    state.workersList = action.payload || [];
  }
};

const handleGetDuplicateWorkersFulfilled = (state, action) => {
  state.status = "succeeded";
  console.log('action.payload.data', action.payload)
  state.duplicateWorkersList = action.payload.data;
  state.currentPage = action.payload.current_page;
  state.perPage = action.payload.per_page;
  state.totalPages = action.payload.total_pages;
  state.totalWorkers = action.payload.total;
  state.lastUpdated = action.payload.last_update;
  state.matched_columns = action.payload.matched_columns || [];

};

const handleQRBranchGenerateCodeFulfilled = (state, action) => {
  state.status = "succeeded";
  state.branchQRCodeData = action.payload.data;
}

const handleSearchInterpreterStaffFulfilled = (state) => {
  state.status = "succeeded";
}

const handleChangeInterpreterFulfilled = (state) => {
  state.status = "succeeded";
}

const handleUpdateWorkerStatusFulfilled = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handleUpdateWorkerProfileImageFulfilled = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handlePartnerWorkerUpdateProfileImg = (state) => {
  state.status = "succeeded";
  // state.partnerWOrkerUpdatedProfileImg = action.payload.data;
}


const handleWorkerPhotoUploadRemoveBackgroundFulfilled = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handleSaveWorkerValidateStatusFulfilled = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handleUpdateWorkerDetailsSliceFulfilled = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handleSaveWorkerBiodataFulfilled = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handleSaveWorkerBasicProfileFulfilled = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handleSaveWorkerConsulateFulfilled = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handlesaveWorkerOverseasDetail = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const workerJobOfferAcceptInterviewFulfilled = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const workerJobOfferCancelnterviewFulfilled = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handlesaveAssignPTWorker = (state, action) => {
  state.status = "succeeded";
  state.message = action.payload.message;
};

const handleWorkerValidateStatusFulfilled = (state, action) => {
  state.status = "succeeded";
  state.allStatusList = action.payload.data;
};

const handleWorkerActivityLogFulfilled = (state, action) => {
  state.status = "succeeded";
  state.activityLogList = action.payload.data;
};

const handleWorkerMainActivityLogFulfilled = (state, action) => {
  state.status = "succeeded";
  state.mainActivityLogList = action.payload.data;
}

const handleWorkerJobOfferDetailsFulfiled = (state, action) => {
  state.status = "succeeded";
  state.workerJobOfferDetails = action.payload.data;
};

const handleWorkerJobStatusListFulfilled = (state, action) => {
  state.status = "succeeded";
  state.jobStatusList = action.payload.data;
};

const handleFetchLeavingReasonFulfilled = (state, action) => {
  state.status = "succeeded";
  state.leavingReasonsList = action.payload.data;
};

const handleGetWorkerJobOffersFulfilled = (state, action) => {
  state.status = "succeeded";
  if (action.payload && action.payload.data) {
    console.log('action.payload.data', action.payload.data)
    state.workerJobOfferList = action.payload.data;
    state.currentPage = action.payload.data.current_page;
    state.perPage = action.payload.data.per_page;
    state.totalPages = action.payload.data.last_page;
    state.totalWorkers = action.payload.data.total;
  } else {
    state.workerJobOfferList = action.payload || [];
  }
};

const haneleFetchWorkerJobStatusFulfilled = (state, action) => {
  state.status = "succeeded";
  state.workerJobStatus = action?.payload?.data;
}

export {
  handleWorkerRoleFulfilled,
  handleWorkerDetailFulfilled,
  handleGetWorkersFulfilled,
  handleUpdateWorkerStatusFulfilled,
  handleSaveWorkerBiodataFulfilled,
  handleSaveWorkerBasicProfileFulfilled,
  handleSaveWorkerConsulateFulfilled,
  handlesaveWorkerOverseasDetail,
  handlesaveAssignPTWorker,
  handleWorkerValidateStatusFulfilled,
  handleWorkerActivityLogFulfilled,
  handleWorkerMainActivityLogFulfilled,
  handleSaveWorkerValidateStatusFulfilled,
  handleWorkerCommonStateInfoFulfilled,
  handleFetchWorkerRefIdInitialsFulfilled,
  handleWorkerDetailTabInfoFulfilled,
  handleWorkerDocumentUploadInfoFulfilled,
  handleWorkerPhotoInfoFulfilled,
  handleWorkerPhotoUploadRemoveBackgroundFulfilled,
  handleUpdateWorkerProfileImageFulfilled,
  handlePartnerWorkerUpdateProfileImg,
  handleWorkerJobOfferDetailsFulfiled,
  handleWorkerJobStatusListFulfilled,
  handleUpdateWorkerDetailsSliceFulfilled,
  handleFetchLeavingReasonFulfilled,
  handleGetWorkerJobOffersFulfilled,
  workerJobOfferAcceptInterviewFulfilled,
  workerJobOfferCancelnterviewFulfilled,
  handleWorkerDetailTabInfoPassportFulfilled,
  handleWorkerDocumentUploadInfoConsulateFulfilled,
  handleGetDuplicateWorkersFulfilled,
  handleSearchInterpreterStaffFulfilled,
  handleChangeInterpreterFulfilled,
  haneleFetchWorkerJobStatusFulfilled,
  handleQRBranchGenerateCodeFulfilled
};
